/**
 * Swiper dependencies
 *
 * @see https://swiperjs.com/get-started
 */
import { Swiper } from 'swiper';
import { Autoplay, Keyboard, Navigation, Pagination, Scrollbar, Controller } from 'swiper/modules';

/**
 * Initialize the slider.
 *
 * @param {Element} container HTMLElement.
 * @param {Object}  options   Slider parameters.
 *
 * @return {Object} Returns initialized slider instance.
 *
 * @see https://swiperjs.com/swiper-api#parameters
 */
export function SwiperInit( container, options = {} ) {
	let swiperInstance;
	
	const parameters = {
		autoplay: options?.autoplay ?? false,
		autoHeight: options?.autoHeight ?? false,
		loop: true,
		centeredSlides: options?.centeredSlides ?? false,
		createElements: true,
		grabCursor: true,
		initialSlide: 0,
		keyboard: true,
		modules: [Autoplay, Keyboard, Navigation, Pagination, Scrollbar, Controller],
		navigation: options?.navigation
		  ? {
			  prevEl: '.jormi-swiper-prev',
			  nextEl: '.jormi-swiper-next',
			}
		  : false,
		pagination: options?.pagination ?? false,
		scrollbar: options?.scrollbar ?? false,
		simulateTouch: options?.simulateTouch ?? true,
		slidesPerView: options.variant === 'single' ? 1 : 'auto',
		spaceBetween: options.variant === 'minimal' ? 24 : 16,
		slidesPerGroup: 1,
		// breakpoints: {
		// 	// Default
		// 	0: {
		// 		slidesPerView: 1,
		// 		spaceBetween: 16,
		// 		slidesPerGroup: 1,
		// 	},
		// 	// Desktop
		// 	992: {
		// 		slidesPerView: options.variant === 'single' ? 1 : 'auto',
		// 		spaceBetween: options.variant === 'dual' ? 48 : 16,
		// 		slidesPerGroup: 1,
		// 	},
		// },
		on: {
		  init: function (swiper) {
			swiperInstance = swiper;
		  },
		  
		},
	  };


	const swiper = new Swiper(container, parameters);

	if (container.classList.contains('swiper-controller')) {
		const controlledEl = document.querySelector('.swiper-controlled');
		if (controlledEl) {
			const controlledSwiper = new Swiper(controlledEl, {
				allowTouchMove: false,
				centeredSlides: false,
				loop: true,
			});
			swiper.controller.control = controlledSwiper;
		}
	}
	
	return swiper;
}
